import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import ordersQuery from '~/graphql/user/orders.gql';
import orderQuery from '~/graphql/user/order.gql';

function fetchCustomerOrderList(_x) {
  return _fetchCustomerOrderList.apply(this, arguments);
}

function _fetchCustomerOrderList() {
  _fetchCustomerOrderList = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.app.apolloProvider.defaultClient.query({
              query: ordersQuery
            });

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCustomerOrderList.apply(this, arguments);
}

function fetchCustomerOrder(_x2, _x3) {
  return _fetchCustomerOrder.apply(this, arguments);
}

function _fetchCustomerOrder() {
  _fetchCustomerOrder = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context, reference) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context2.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              query: orderQuery,
              variables: {
                reference: reference,
                locale: locale
              }
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchCustomerOrder.apply(this, arguments);
}

function fetchCustomer(_x4) {
  return _fetchCustomer.apply(this, arguments);
}

function _fetchCustomer() {
  _fetchCustomer = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context) {
    var locale, xhrUri, _ref, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/ajax_customer_details.json");
            _context3.next = 4;
            return context.$axios.get(xhrUri, {
              withCredentials: true
            });

          case 4:
            _ref = _context3.sent;
            data = _ref.data;
            return _context3.abrupt("return", data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchCustomer.apply(this, arguments);
}

function addCartCustomizable(_x5, _x6) {
  return _addCartCustomizable.apply(this, arguments);
}

function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(context, payload) {
    var locale, xhrUri, _ref2, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/custom/panier/").concat(payload);
            _context4.next = 4;
            return context.$axios.get(xhrUri, {
              'axios-retry': {
                retries: 0
              }
            });

          case 4:
            _ref2 = _context4.sent;
            data = _ref2.data;
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _addCartCustomizable.apply(this, arguments);
}

function addCart(_x7, _x8) {
  return _addCart.apply(this, arguments);
}

function _addCart() {
  _addCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(context, payload) {
    var locale, xhrUri, _ref3, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/").concat(payload.referenceEncoded, "/").concat(payload.quantity);
            _context5.next = 4;
            return context.$axios.get(xhrUri, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              'axios-retry': {
                retries: 0
              }
            });

          case 4:
            _ref3 = _context5.sent;
            data = _ref3.data;
            return _context5.abrupt("return", data);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _addCart.apply(this, arguments);
}

function updateCart(_x9, _x10) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(context, payload) {
    var locale, xhrUri, _ref4, data;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/changer/").concat(payload.reference, "/").concat(payload.quantity);
            _context6.next = 4;
            return context.$axios.get(xhrUri, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            });

          case 4:
            _ref4 = _context6.sent;
            data = _ref4.data;
            return _context6.abrupt("return", data);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _updateCart.apply(this, arguments);
}

export { fetchCustomer, fetchCustomerOrderList, fetchCustomerOrder, addCart, addCartCustomizable, updateCart };